// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PlanType {
    MEDICARESECONDARYWORKINGAGEDBENEFICIARY = 'MEDICARE_SECONDARY_WORKING_AGED_BENEFICIARY',
    MEDICARESECONDARYENDSTAGERENALDISEASEBENEFICIARY = 'MEDICARE_SECONDARY_END_STAGE_RENAL_DISEASE_BENEFICIARY',
    MEDICARESECONDARYNOFAULTINSURANCEAUTOPRIMARY = 'MEDICARE_SECONDARY_NO_FAULT_INSURANCE_AUTO_PRIMARY',
    MEDICARESECONDARYWORKERSCOMPENSATION = 'MEDICARE_SECONDARY_WORKERS_COMPENSATION',
    MEDICARESECONDARYPUBLICHEALTHSERVICE = 'MEDICARE_SECONDARY_PUBLIC_HEALTH_SERVICE',
    MEDICARESECONDARYBLACKLUNG = 'MEDICARE_SECONDARY_BLACK_LUNG',
    MEDICARESECONDARYVETERANSADMINISTRATION = 'MEDICARE_SECONDARY_VETERANS_ADMINISTRATION',
    MEDICARESECONDARYDISABLEDBENEFICIARYUNDERAGE65 = 'MEDICARE_SECONDARY_DISABLED_BENEFICIARY_UNDER_AGE_65',
    MEDICARESECONDARYOTHERLIABILITYINSURANCEPRIMARY = 'MEDICARE_SECONDARY_OTHER_LIABILITY_INSURANCE_PRIMARY',
    AUTOINSURANCEPOLICY = 'AUTO_INSURANCE_POLICY',
    COMMERCIAL = 'COMMERCIAL',
    COBRA = 'COBRA',
    MEDICARECONDITIONALLYPRIMARY = 'MEDICARE_CONDITIONALLY_PRIMARY',
    DISABILITY = 'DISABILITY',
    DISABILITYBENEFITS = 'DISABILITY_BENEFITS',
    EXCLUSIVEPROVIDERORGANIZATION = 'EXCLUSIVE_PROVIDER_ORGANIZATION',
    FAMILYORFRIENDS = 'FAMILY_OR_FRIENDS',
    GROUPPOLICY = 'GROUP_POLICY',
    HMO = 'HMO',
    HMOMEDICARERISK = 'HMO_MEDICARE_RISK',
    SPECIALLOWINCOMEMEDICAREBENEFICIARY = 'SPECIAL_LOW_INCOME_MEDICARE_BENEFICIARY',
    INDEMNITY = 'INDEMNITY',
    INDIVIDUALPOLICY = 'INDIVIDUAL_POLICY',
    LONGTERMCARE = 'LONG_TERM_CARE',
    LONGTERMPOLICY = 'LONG_TERM_POLICY',
    LIFEINSURANCE = 'LIFE_INSURANCE',
    LITIGATION = 'LITIGATION',
    MEDICAREPARTA = 'MEDICARE_PART_A',
    MEDICAREPARTB = 'MEDICARE_PART_B',
    MEDICAID = 'MEDICAID',
    MEDIGAPPARTA = 'MEDIGAP_PART_A',
    MEDIGAPPARTB = 'MEDIGAP_PART_B',
    MEDICAREPRIMARY = 'MEDICARE_PRIMARY',
    OTHER = 'OTHER',
    PROPERTYINSURANCEPERSONAL = 'PROPERTY_INSURANCE_PERSONAL',
    PERSONAL = 'PERSONAL',
    PERSONALPAYMENTCASHNOINSURANCE = 'PERSONAL_PAYMENT_CASH_NO_INSURANCE',
    PPO = 'PPO',
    POS = 'POS',
    QUALIFIEDMEDICAREBENEFICIARY = 'QUALIFIED_MEDICARE_BENEFICIARY',
    PROPERTYINSURANCEREAL = 'PROPERTY_INSURANCE_REAL',
    SUPPLEMENTALPOLICY = 'SUPPLEMENTAL_POLICY',
    TERFA = 'TERFA',
    WORKERSCOMPENSATION = 'WORKERS_COMPENSATION',
    WRAPUPPOLICY = 'WRAP_UP_POLICY',
    UNKNOWN = 'UNKNOWN'
}

export function PlanTypeFromJSON(json: any): PlanType {
    return json as PlanType;
}

export function PlanTypeToJSON(value?: PlanType): any {
    return value as any;
}

